import React, { useState, useEffect } from "react";
import { Modal, Table, Tag, message } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";

const ViewBaptismalStatusChangeRecordsModal = ({
	visible,
	onCancel,
	userId,
	userName,
}) => {
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (visible && userId) {
			fetchRecords();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run only when visible/userId
	}, [visible, userId]);

	const fetchRecords = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get(
				`/users/baptismal-status-change-records/${userId}/`
			);
			if (response.status === 200) {
				setRecords(response.data);
			}
		} catch (error) {
			message.error(
				"세례 상태 변경 기록을 불러오는데 실패했습니다."
			);
		} finally {
			setLoading(false);
		}
	};

	const columns = [
		{
			title: "세례일",
			dataIndex: "baptismal_date",
			key: "baptismal_date",
			render: (date) => dayjs(date).format("YYYY-MM-DD"),
			sorter: (a, b) =>
				dayjs(a.baptismal_date).unix() -
				dayjs(b.baptismal_date).unix(),
			defaultSortOrder: "descend",
		},
		{
			title: "세례 상태",
			dataIndex: "baptismal_status_type",
			key: "baptismal_status_type",
			render: (status) => <Tag color="green">{status}</Tag>,
		},
		{
			title: "세례 목사",
			dataIndex: "baptizing_pastor",
			key: "baptizing_pastor",
			render: (pastor) => pastor || "-",
		},
		{
			title: "세례 교회",
			dataIndex: "baptismal_church",
			key: "baptismal_church",
			render: (church) => church || "-",
		},
	];

	return (
		<Modal
			title={
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "8px",
					}}>
					<HistoryOutlined />
					<span>
						{userName}님의 세례 상태 변경
						기록
					</span>
				</div>
			}
			open={visible}
			onCancel={onCancel}
			footer={null}
			width={900}>
			<Table
				columns={columns}
				dataSource={records}
				rowKey="id"
				loading={loading}
				pagination={{
					pageSize: 10,
					showSizeChanger: true,
					showQuickJumper: true,
					showTotal: (total, range) =>
						`${range[0]}-${range[1]} / 총 ${total}개`,
				}}
				locale={{
					emptyText: "변경 기록이 없습니다.",
				}}
			/>
		</Modal>
	);
};

export default ViewBaptismalStatusChangeRecordsModal;
